import type { ExportDatasetKey } from "./constants";
import { ENTITY_PLUS_GATED_DATASETS } from "./constants";

/**
 * Removes Entity+-gated datasets when Entity+ is inactive.
 * Pure function: no I/O, no side effects.
 *
 * @param selected - Dataset keys the user selected in the modal
 * @param isEntityPlusActive - Whether the entity (or any selected entity) has Entity+ active
 * @returns Only the selected keys that are allowed (non-gated, or gated but Entity+ is active)
 */
export function filterAllowedDatasets(
  selected: readonly ExportDatasetKey[],
  isEntityPlusActive: boolean,
): ExportDatasetKey[] {
  if (isEntityPlusActive) {
    return [...selected];
  }
  return selected.filter(
    (key) => !(ENTITY_PLUS_GATED_DATASETS as readonly string[]).includes(key),
  ) as ExportDatasetKey[];
}
